import type {
  LoginEnrollOptions,
  MfaLoginFactorType,
  ScreenMembersOnMfaLoginOptions,
} from '@auth0/auth0-acul-react/types';
import {
  enroll,
  returnToPrevious,
  useMfaLoginOptions,
  useScreen,
} from '@auth0/auth0-acul-react/mfa-login-options';

import { executeSafely } from '@/utils/helpers/executeSafely';

// Only handle SMS and Email factors
const SUPPORTED_FACTORS: MfaLoginFactorType[] = ['sms', 'email'];

export const useMfaLoginOptionsManager = () => {
  const { texts } = useScreen();
  const mfaLoginOptions = useMfaLoginOptions();

  // Get enrolled factors from user data
  const enrolledFactors = mfaLoginOptions.user?.enrolledFactors ?? [];

  // Filter to only supported factors (SMS and Email)
  const supportedEnrolledFactors = enrolledFactors.filter((factor) =>
    SUPPORTED_FACTORS.includes(factor as MfaLoginFactorType),
  );

  const handleEnroll = async (payload: LoginEnrollOptions): Promise<void> => {
    await executeSafely(
      `Enroll into the MFA factor: ${JSON.stringify(payload)}`,
      () => enroll(payload),
    );
  };

  const handleSelectFactor = async (
    factor: MfaLoginFactorType,
  ): Promise<void> => {
    await enroll({ action: factor });
  };

  const handleReturnToPrevious = async (): Promise<void> => {
    await executeSafely('Return to previous screen', () =>
      returnToPrevious({}),
    );
  };

  return {
    mfaLoginOptions,
    handleEnroll,
    handleSelectFactor,
    handleReturnToPrevious,
    texts: (texts || {}) as ScreenMembersOnMfaLoginOptions['texts'],
    enrolledFactors,
    supportedEnrolledFactors,
  };
};
